import { getSize } from "../../common/clickstream/schemas/clickstream-util";

class ErrorService {
  constructor() {
    this.error = null;
  }

  setError(error) {
    this.error = error;
  }

  getError() {
    return this.error;
  }

  static hydrateSentryEvent(event, hint) {
    const error = hint.originalException;
    const rawData = error.data || {};
    const sendToSentry = error.sendToSentry;
    const originalError = error.originalError || {};
    const status = originalError.status || error.status;

    event.extra = {
      message: error.message,
      status,
      code: error.code,
      device: getSize(),
      location: window.location.pathname,
      queryParams: window.location.search,
    };

    if (Object.keys(rawData).length > 0) {
      event.extra.rawData = rawData;
    }

    if (sendToSentry === false) {
      return null;
    }

    return event;
  }
}

export default ErrorService;



// WEBPACK FOOTER //
// ./client/app/components/error/error.service.js